module.exports = __webpack_public_path__ + "fonts/needsWork.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/needsWork.svg
// module id = 2506
// module chunks = 0